var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgDateCalendar = function SvgDateCalendar(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10H19V9H18V10H14V9H13V10H11C10.45 10 10 10.45 10 11V21C10 21.55 10.45 22 11 22H21C21.55 22 22 21.55 22 21V11C22 10.45 21.55 10 21 10ZM21 21H11V14H21V21ZM21 13H11V11H13V12H14V11H18V12H19V11H21V13Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgDateCalendar);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMjEgMTBIMTlWOUgxOFYxMEgxNFY5SDEzVjEwSDExQzEwLjQ1IDEwIDEwIDEwLjQ1IDEwIDExVjIxQzEwIDIxLjU1IDEwLjQ1IDIyIDExIDIySDIxQzIxLjU1IDIyIDIyIDIxLjU1IDIyIDIxVjExQzIyIDEwLjQ1IDIxLjU1IDEwIDIxIDEwWk0yMSAyMUgxMVYxNEgyMVYyMVpNMjEgMTNIMTFWMTFIMTNWMTJIMTRWMTFIMThWMTJIMTlWMTFIMjFWMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";